import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions'

export default {
  name: 'ceremony',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    EditorContent,
    EditorMenuBar
  },
  computed: {
    env () {
      return this.$store.getters.env
    },
    user () {
      return this.$store.getters.user
    },
    titleState () {
      return this.ceremony.title && this.ceremony.title.length < 50
    },
    descriptionState () {
      return this.ceremony.description && this.ceremony.description !== '<p><br></p>'
    },
    dateState () {
      let dt = new Date()
      this.ceremony.date = new Date(this.selected.year, this.selected.month - 1, this.selected.day, this.selected.hour, this.selected.min)

      return this.ceremony.date > dt
    },
    placeState () {
      return this.ceremony.place && this.ceremony.title.length < 50
    },
    lengthState () {
      return this.ceremony.length && this.ceremony.title.length < 20
    },
    contactState () {
      return this.ceremony.contact && this.ceremony.title.length > 0
    },
    phoneState () {
      return this.ceremony.phone && this.ceremony.title.length > 0
    },
    storeState () {
      return this.titleState &&
        this.descriptionState &&
        this.dateState &&
        this.placeState &&
        this.lengthState &&
        this.contactState &&
        this.phoneState
    }
  },
  data () {
    return {
      sidebar_tab: '3',
      loading: false,
      updating: false,
      smartthon: {},
      smartthonId: this.$route.params.smartthonId,
      ceremony: {
        title: '',
        description: '',
        place: '',
        length: '',
        contact: '',
        phone: '',
        date: ''
      },
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: '表彰式の内容を入力してください。',
        onUpdate: ({ getJSON, getHTML }) => {
          this.ceremony.description = getHTML().replace(/<p><\/p>/g, '<p><br></p>')
        }
      }),
      yearOptions: [],
      monthOptions: [],
      dayOptions: [],
      hourOptions: [],
      minOptions: [
        { value: 0, text: '00' },
        15,
        30,
        45
      ],
      selected: {
        year: '',
        month: '',
        day: '',
        hour: '',
        min: ''
      },
      preview: '',
      isModal: false,
      alert: {
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: 'danger',
        message: ''
      }
    }
  },
  mounted () {
    this.setDate()
    this.setPreview()
    this.fetchData()
  },
  methods: {
    setDate (date) {
      let dt = new Date()
      if (date) dt = new Date(date)
      this.selected.year = dt.getFullYear()
      this.selected.month = dt.getMonth() + 1
      this.selected.day = dt.getDate()
      this.selected.hour = dt.getHours()
      if (dt.getMinutes() >= 0 && dt.getMinutes() < 15) {
        this.selected.min = 15
      } else if (dt.getMinutes() >= 15 && dt.getMinutes() < 30) {
        this.selected.min = 30
      } else if (dt.getMinutes() >= 30 && dt.getMinutes() < 45) {
        this.selected.min = 45
      } else if (dt.getMinutes() >= 45) {
        dt.setHours(dt.getHours() + 1)
        this.selected.year = dt.getFullYear()
        this.selected.month = dt.getMonth() + 1
        this.selected.day = dt.getDate()
        this.selected.hour = dt.getHours()
        this.selected.min = 0
      }

      this.yearOptions = [ this.selected.year, this.selected.year + 1 ]
      for (let i = 1; i < 13; i++) this.monthOptions.push(i)
      for (let i = 1; i < 32; i++) this.dayOptions.push(i)
      for (let i = 0; i < 24; i++) this.hourOptions.push(i)
    },
    setPreview () {
      this.preview = `${this.env.DOMAIN.replace('ent', 'app')}/smartthon/${this.$route.params.smartthonId}/ceremony`
    },
    fetchData () {
      let pathParams = {
        smartthonId: this.$route.params.smartthonId
      }

      let additionalParams = {
        queryParams: {
          enterpriseId: this.user.enterpriseId,
          type: 'ceremony'
        }
      }

      this.$apig.get(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, {})
        .then(response => {
          this.smartthon = response.data.smartthon
          if (Object.keys(response.data.ceremony).length) {
            this.ceremony = response.data.ceremony
            if (response.data.ceremony.description) this.editor.setContent(response.data.ceremony.description.replace(/<p><br><\/p>/g, '<p></p>'))
          }

          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateCeremony () {
      this.updating = true

      let pathParams = {
        smartthonId: this.$route.params.smartthonId
      }

      let additionalParams = {
        queryParams: {
          type: 'ceremony'
        }
      }

      let body = {
        ceremony: this.ceremony
      }

      this.$apig.patch(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, body)
        .then(response => {
          // 成功のアラート
          this.isModal = true
          this.updating = false
        })
        .catch(err => {
          // 失敗のアラート
          this.alert.dismissCountDown = this.alert.dismissSecs
          this.alert.message = (err.response.data.message ? err.response.data.message : '一時的なエラーが発生しています。時間を置いてお試しください。')
          this.updating = false
        })
    },
    countDownChanged (dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/ceremony/ceremony.js